module.exports = __webpack_public_path__ + "static/media/3bhk.22b7ac45.jpg";